import React, { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Plus, PlusCircle, Layers } from 'lucide-react';
import ProductList from '../components/products/ProductList';
import ProductForm from '../components/products/ProductForm';
import MultipleProductsForm from '../components/products/MultipleProductsForm';
import useAuth from '../hooks/useAuth';

const ProductManagement = () => {
    const { isAdmin, isManager } = useAuth();
    const [view, setView] = useState('list');
    const [selectedProductId, setSelectedProductId] = useState(null);

    const canModify = isAdmin || isManager;

    const handleAddProduct = () => {
        setSelectedProductId(null);
        setView('form');
    };

    const handleAddMultipleProducts = () => {
        setView('multiple');
    };

    const handleEditProduct = (productId) => {
        setSelectedProductId(productId);
        setView('form');
    };

    const handleViewProduct = (productId) => {
        // Pour le moment, juste rediriger vers l'édition
        // Idéalement, vous auriez une vue de détails en lecture seule
        setSelectedProductId(productId);
        setView('form');
    };

    const handleCancel = () => {
        setView('list');
        setSelectedProductId(null);
    };

    const handleSuccess = () => {
        setView('list');
        setSelectedProductId(null);
    };

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="h3">Gestion des produits</h1>

                {/* {canModify && view === 'list' && (
                    <div>
                        <Button
                            variant="outline-primary"
                            className="me-2"
                            onClick={handleAddMultipleProducts}
                        >
                            <Layers size={16} className="me-1" />
                            Ajouter plusieurs
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleAddProduct}
                        >
                            <PlusCircle size={16} className="me-1" />
                            Nouveau produit
                        </Button>
                    </div>
                )} */}
            </div>

            {view === 'list' && (
                <ProductList
                    onAddProduct={handleAddProduct}
                    onEditProduct={handleEditProduct}
                    onViewProduct={handleViewProduct}
                />
            )}

            {view === 'form' && (
                <ProductForm
                    productId={selectedProductId}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}

            {view === 'multiple' && (
                <MultipleProductsForm
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}
        </Container>
    );
};

export default ProductManagement;